<template>
  <div class="detail-view-sub">
    <el-drawer
      title="查看明细"
      :visible.sync="innerVisible"
      size="70%"
      :append-to-body="true"
      class="theme-dialog dialog-center"
      :before-close="handleClose"
      :destroy-on-close="true"
    >
      <div class="px-6 pt-6">
        <div>
          <div class="flex justify-start mb-4">
            <div v-if="settleObjType == 0" class="inline-block" style="width: 40%">
              <div class="inline-block" style="width: 70px; text-align: right">
                <span class="text-theme-black-450 text-medium">调查员：</span>
              </div>
              <span class="text-theme-black-850 text-medium">{{ preRows.investigatorName }}-{{ preRows.investigatorPhone }}</span>
            </div>
            <div v-if="settleObjType == 1" class="inline-block" style="width: 40%">
              <span class="text-theme-black-450 text-medium">代理名称：</span>
              <span class="text-theme-black-850 text-medium">{{ preRows.investigatorName }}</span>
            </div>
            <div class="inline-block" v-if="preRows.projectCategory == 1 && preRows.settleMode != 4">
              <span class="text-theme-black-450 text-medium">调查日期：</span>
              <!-- <span class="text-theme-black-850 text-medium" v-if="preRows.settleMode==1">{{ rows.investigateStartTime }}~{{ rows.investigateEndTime }}</span> -->
              <span class="text-theme-black-850 text-medium">{{ rows.investigateDateStr }}</span>
            </div>
            <div class="inline-block" v-if="preRows.projectCategory == 1 && preRows.settleMode == 4">
              <span class="text-theme-black-450 text-medium">点位：</span>
              <span class="text-theme-black-850 text-medium">{{ rows.area }}</span>
            </div>
          </div>
          <div class="flex justify-start mb-4">
            <div class="inline-block" style="width: 40%" v-if="preRows.projectCategory == 0">
              <span class="text-theme-black-450 text-medium">答卷数量：</span>
              <span class="text-theme-black-850 text-medium">&nbsp;{{ rows.itemNum }}&nbsp;份</span>
            </div>
            <div class="inline-block" style="width: 40%" v-if="preRows.projectCategory == 1 && preRows.settleMode != 4">
              <span class="text-theme-black-450 text-medium">案件数量：</span>
              <span class="text-theme-black-850 text-medium">&nbsp;{{ rows.itemNum }}&nbsp;个</span>
            </div>
            <div class="inline-block" style="width: 40%" v-if="preRows.projectCategory == 1 && preRows.settleMode != 4">
              <span class="text-theme-black-450 text-medium">关联点位：</span>
              <span class="text-theme-black-850 text-medium">&nbsp;{{ rows.areaNum }}&nbsp;个</span>
            </div>
          </div>
        </div>
        <div>
          <div class="flex mb-4" v-if="preRows.projectCategory == 1 && preRows.settleMode != 4">
            <search-filter :search-filters="searchFields" :change-handel-function="onChangeSearchField" ref="sf" />
            <div class="inline-block ml-3" style="width: 140px">
              <el-button class="" type="primary" @click="toSearch">
                <span class="px-0.5">查询</span>
              </el-button>
              <el-button class="ml-3" @click="onReset">
                <span class="px-0.5">重置</span>
              </el-button>
            </div>
          </div>
          <data-table
            align="left"
            :data="tableData"
            :columns="tableColumn"
            :page="page"
            :showPage="true"
            :loading="loading"
            :selection="(preRows.deletable == undefined ? true : preRows.deletable) && pageType == 1"
            :checkAll.sync="checkAll"
            :isShowCheckCount="(preRows.deletable == undefined ? true : preRows.deletable) && pageType == 1"
            :isShowCheckAll="(preRows.deletable == undefined ? true : preRows.deletable) && pageType == 1"
            @size-change="sizeChange"
            @pagination-current-change="currentChange"
            @selection-change="selectionChange"
            ref="tableRef"
            :height="
              preRows.projectCategory == 1 && preRows.settleMode == 4
                ? 'calc(100vh - 180px)'
                : preRows.projectCategory == 1 && preRows.settleMode != 4
                ? 'calc(100vh - 255px)'
                : 'calc(100vh - 199px)'
            "
          >
            <!-- 菜单 -->
            <template #opt="{ row }">
              <el-button
                v-if="preRows.projectCategory == 0 || (preRows.projectCategory == 1 && row.viewable)"
                @click="toSubDetail(row)"
                type="text"
                >查看明细</el-button
              >
              <el-tooltip v-else class="item" content="暂不支持查看案件详情，如需查看，请联系审批发起人" placement="top">
                <el-button :disabled="true" :key="'a'" type="text">查看明细</el-button>
              </el-tooltip>
              <!-- 明细在编辑时才有移除 -->
              <el-button
                v-if="(preRows.deletable == undefined ? true : preRows.deletable) && pageType == 1"
                @click="toSubDelete(row)"
                type="text"
                >移除</el-button
              >
            </template>
            <template slot="page-left" v-if="(preRows.deletable == undefined ? true : preRows.deletable) && pageType == 1">
              <div class="inline-block">
                <el-button type="primary" @click="toBatchSubDelete()" :disabled="selectionList.length == 0">移除</el-button>
              </div>
            </template>
          </data-table>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { searchFieldsSub, surveyTableColumnSub, inquiryTableColumnSub, inquiryTableColumnSubPoint } from './DetailViewOptions'
import SearchFilter from '@/components/search-filter/SearchFilter'
import DataTable from '@/components/base/DataTable'
import { getItemList, itemRemove } from '@/api/cost-settlement/settlement-initiate/relateProject'
import { deepClone } from '@/assets/js/utils'
import GlobalConfig from '@/global/config'

export default {
  name: '',
  components: { SearchFilter, DataTable },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    preRows: {
      type: Object,
      default: () => {}
    },
    rows: {
      type: Object,
      default: () => {}
    },
    pageType: {
      // 0新增，1编辑, 2查看
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      settleObjType: 0,
      searchFields: searchFieldsSub,
      selectionList: [],
      selectedIds: [],
      settleMode: 4,
      settleRule: {
        unitPriceYuan: undefined,
        inspectAllStandard: false,
        tiers: [
          {
            unitPriceYuan: undefined,
            quantityLowerBound: 0,
            quantityUpperBound: undefined
          }
        ]
      },
      settleModeMap: {
        4: 'Point',
        3: 'Stair',
        2: 'Day',
        1: 'Answer'
      },
      tableColumn: [],
      surveyTableColumnSub,
      inquiryTableColumnSub,
      inquiryTableColumnSubPoint,
      tableData: [],
      page: {
        total: 1,
        currentPage: 1,
        pageSize: 20,
        pageSizes: [10, 20, 30, 50, 100]
      },
      loading: false,
      checkAll: false,
      info: {
        investigatorsNum: 0,
        expectedYuanAmount: 0,
        serviceYuanAmount: 0,
        operationalYuanAmount: 0
      },
      forms: {}
    }
  },
  watch: {
    visible(v) {
      if (v) {
        if (this.preRows.projectCategory == 0) {
          this.tableColumn = this.surveyTableColumnSub
        } else if (this.preRows.projectCategory == 1) {
          if (this.preRows.settleMode == 4) {
            this.tableColumn = this.inquiryTableColumnSubPoint
          } else {
            this.tableColumn = this.inquiryTableColumnSub
          }
        }
        this.getList()
      } else {
        this.onReset(1)
      }
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    toSubDetail(row) {
      if (this.preRows.projectCategory == 0) {
        window.open(
          `${window.location.origin + process.env.VUE_APP_PRE_URL}/#/item-detail/survey?` +
            `answerId=${row.originId}&investigatorName=${row.investigatorName}&investigatorPhone=${row.investigatorPhone}`
        )
      } else if (this.preRows.projectCategory == 1) {
        let projectId = row.originProjectId || ''
        let caseId = row.originId || ''
        let token = GlobalConfig.getBaseToken()
        let url = `${process.env.VUE_APP_MCAF_DOMAIN}/projects/${projectId}/detail?id=${caseId}&token=${token}`
        window.open(url)
        // window.open(
        //   `${window.location.origin + process.env.VUE_APP_PRE_URL}/#/item-detail/inquiry?projectId=${
        //     row.originProjectId
        //   }&caseId=${row.originId}&investigatorName=${row.investigatorName}&investigatorPhone=${row.investigatorPhone}`
        // )
      }
    },
    toSubDelete(row) {
      this.$confirm('移除后无法撤消', '确定移除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            selectedIds: [row.id],
            query: this.handleData()
          }
          this.itemRemove(params)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消移除'
          })
        })
    },
    toBatchSubDelete() {
      if (!this.checkAll) {
        if (this.selectionList.length == 0) {
          this.$message.warning('请选择数据')
          return
        }
      }
      this.$confirm('移除后无法撤消', '确定移除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            selectedIds: this.selectedIds,
            query: this.handleData()
          }
          if (this.checkAll) {
            params.selectedIds = []
          }
          this.itemRemove(params).then(() => {
            this.$refs.tableRef.clearSelection()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消移除'
          })
        })
    },
    itemRemove(params) {
      return itemRemove(params)
        .then(res => {
          if (res.data.code != 0) {
            this.$message.error(res.data.msg)
            return
          }
          this.$message.success('操作成功')
          this.getList()
        })
        .catch(e => {
          console.log(e)
        })
    },
    handleClose() {
      this.innerVisible = false
    },
    // 获取列表
    getList() {
      this.loading = true
      getItemList(this.handleData())
        .then(res => {
          if (res.data.code != 0) {
            this.$message.error(res.data.msg)
            this.loading = false
            return
          }
          this.page.total = res.data.data.total
          this.page.currentPage = res.data.data.current
          this.page.pageSize = res.data.data.size
          this.tableData = res.data.data.records
          this.info = res.data.data

          this.tableData.forEach(item => {
            item.investigateTime = item.investigateTime?.substr(0, 16)
            item.expectedYuanAmount = item.expectedYuanAmount ? Number(item.expectedYuanAmount).toFixed(2) : ''
            item.serviceYuanAmount = item.serviceYuanAmount ? Number(item.serviceYuanAmount).toFixed(2) : ''
            item.operationalYuanAmount = item.operationalYuanAmount ? Number(item.operationalYuanAmount).toFixed(2) : ''
          })
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    },
    // 整理请求数据
    handleData() {
      let fs = deepClone(this.forms)
      fs.itemGroupId = this.rows.id
      fs.statementId = this.$route.query.statementId
      if (this.preRows.projectId) {
        fs.projectId = this.preRows.projectId
      }
      if (this.preRows.investigatorStatementId) {
        fs.investigatorStatementId = this.preRows.investigatorStatementId
      }
      fs.investigatorDetailId = this.rows.investigatorDetailId
      fs.forLink = this.pageType == 0 ? true : false
      fs.current = this.page.currentPage
      fs.size = this.page.pageSize
      fs.descs = 'create_time'
      return fs
    },
    onChangeSearchField(params) {
      this.forms = params
    },
    toSearch() {
      this.checkAll = false
      this.$refs.tableRef?.clearSelection()
      this.page.currentPage = 1
      this.getList()
    },
    onReset(type) {
      this.$refs.sf?.reset()
      this.forms = {}
      this.checkAll = false
      this.$refs.tableRef?.clearSelection()
      if (type != 1) {
        this.page.currentPage = 1
        this.getList()
      }
    },
    selectionChange(val) {
      this.selectionList = val
      this.selectedIds = val.map(el => {
        return el.id
      })
    },
    // 点击 每页显示条数 触发
    sizeChange(val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      this.getList(1)
    },
    // 切换页面 （点击页码、数字、输入数字） 触发
    currentChange(val) {
      this.page.currentPage = val
      this.getList(1)
    }
  },
  created() {},
  mounted() {
    this.settleObjType = this.$route.query.settleObjType
  }
}
</script>
<style lang="scss" scoped></style>
